import { Component, inject } from '@angular/core';

import { HisAuthService } from 'hisng';
import { SEARCH_CONFIG_UNITS_BY_PERSON } from 'app/cs/psv/common/model/searchConstants';

@Component( {
    selector: 'psv-unit-search-form',
    templateUrl: './unit-search-form.component.html',
    standalone: false
} )
export class UnitSearchFormComponent {
    auth = inject(HisAuthService);

    readonly SEARCH_CONFIG_UNITS_BY_PERSON = SEARCH_CONFIG_UNITS_BY_PERSON;
}
